import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  //English
  en: {
    anErrorOccurredMsg: "An error occurred. Please try again.",
    welcomeMessage: "Welcome to the AATF Knowledge Management Hub",
    slogan: "Knowledge Management Hub",
    discoverMessage: " Discover everything to help with your journey",
    whatYouGetMessage: "What You Get",
    productDevelopment: "PRODUCT DEVELOPMENT & DEPLOYMENT",
    productDevelopmentMessage:
      " This programme encompasses the upstream functions of the technology development pipeline,ranging from scouting and access to development (including trait/agroecological breeding and adaptation). It covers technology proof-of-concept, feasibility determination through cost-benefit analysis (CBA),product/variety testing, release and registration, technology demonstrations, and technical discussions.",
    enablingEnvironment: "ENABLING ENVIRONMENT ",
    enablingEnvironmentMessage:
      "Through this programme, AATF seeks to foster the materialisation of technology development, release, and commercialisation at both country and regional levels. This is achieved through collaborative efforts with governments and relevant organisations for the enactment and implementation of clearly articulated policies, laws, regulations, guidelines, processes, and institutions. These efforts are underpinned by political goodwill and the requisite abilities and resources. ",
    investment: "ACCESS TO INVESTMENT  ",
    investmentMessage:
      "This programme centres on facilitating the commercialisation and scaling-up of products developed through AATF partnership projects. It comprises three crucial components: firstly, the facilitation of efficient and cost-effective seed systems to deliver products directly to farmers. Secondly, stewardship support is provided to ensure the responsible use of these products. And finally, value chain-specific market development is undertaken to bolster access and adoption.",
    searchButton: "Start Search",
    searchMessage: "Search",
    searchHereMessage: "Search Here",
    viewMoreMessage: "View More",
    readMessage: "Read",
    recommendedResearch: "Recommended Research",
    recommendedResearchMessage:
      "Explore our carefully curated selection of recommended research, featuring the latest studies, innovations and insights shaping the future of agriculture in Africa.",
    latestResearch: "Latest Research",
    latestResearchMessage:
      "Stay up-to-date with the latest research in agricultural innovation and technology, addressing emerging challenges and opportunities across Africa. This section highlights newly published studies, breakthrough findings and cutting-edge developments that are shaping the future of agriculture.",
    whoWeWorkWith: "Who We Work With",
    welcomeDetailsMsg:
      "Your gateway to accessing, sharing and managing vital knowledge that fuels innovation and growth in agriculture across Africa. This platform is designed to empower decision-making with curated data, reports and expert insights, foster collaboration by connecting teams and projects and drive innovation through cutting-edge agricultural technologies and success stories. Explore the resources, share ideas and contribute to building a knowledge-driven future for African agriculture.",
    loginMessage: "Login",
    homeMessage: "Home",
    publicationMessage: "Publications",
    IPBioSafetyLawsMessage: "IP & Biosafety Laws",
    mediaMessage: "Media",
    projectsMessage: "Projects",
    opportunitiesMessage: "Opportunities",
    faqsMessage: "FAQs",
    faqsInFullMessage: "Frequently Asked Questions",
    aboutMsg: "About",
    aboutUsMsg: "About Us",
    contactUsMsg: "Contact Us",
    quickLinksMsg: "Quick Links",
    termsAndConditionsMsg: "Terms and Conditions",
    allRightsReservedMsg: "All Rights Reserved",
    signOutMessage: "Sign Out",
    emailMessage: "E-Mail",
    createAccountMessage: "Create Account",
    firstNameMessage: "First Name",
    middleNameMessage: "Middle Name",
    lastNameMessage: "Last Name",
    nameMessage: "Name",
    phoneNumberMessage: "Phone Number",
    accessLevelMessage: "Access Level",
    passwordMessage: "Password",
    confirmPasswordMessage: "Confirm Password",
    registerMessage: "Register",
    createMessage: "Create",
    sendLinkMessage: "Send me a link..",
    sendMsg: "Send",
    confirmOTPMessage: "Confirm Code..",
    inputIsRequiredMessage: "Input is required",
    codeInputIsRequiredMessage: "Please input your code",
    minimum12CharactersMsg: "Minimum 12 characters",
    mustHaveAtLeastOneUppercaseCharacterMsg:
      "Must have at least one uppercase character",
    mustHaveAtLeastOneNumberMsg: "Must have at least one number",
    mustHaveAtLeastOneSpecialCharacterMsg:
      "Must have at least one special character [!@#$%.]",
    mustNotHaveASpecialCharacterMsg: "Must not have a special character",
    passwordIsRequiredMsg: "Password is required",
    backButton: "Back",
    viewMoreLocation: "Location",
    seeMedia: "See Media",
    viewMorePeople: "People",
    viewMoreStatus: "Status",
    viewMoreCountry: "Country",
    countryMsg: "Country",
    phoneNumberIsRequiredMsg: "Phone Number is required",
    mustBeAnIntegerMsg: "Phone Number should only contain numbers",
    minimum10DigitsMsg: "Phone Number should have a minimum of 10 digits",
    passwordConfirmIsRequiredMsg: "Password Confirmation is required",
    passwordsDoNotMatchMsg: "Passwords do not match",
    accountActiveMsg: "Account Active",
    accountCreationDateMsg: "Account Creation Date",
    actionMsg: "Action | Actions",
    yesMsg: "Yes",
    noMsg: "No",
    viewMsg: "View",
    editMsg: "Edit",
    deleteMsg: "Delete",
    loadingMsg: "Loading",
    pleaseWaitMsg: "Please Wait",
    saveMsg: "Save",
    maximumCharsMsg: "Maximum {count} characters",
    minimumCharsMsg: "Minimum {count} characters",
    noResultsMatchedSearchMsg: "No results matched your search",
    noResultsMsg: "No results",
    closeMsg: "Close",
    workflowBillingNodeError: "Error! Cannot submit without billable items",

    emailIsRequiredMsg: "E-Mail is required",
    emailMustBeValidMsg: "E-Mail must be valid",
    profileMessage: "Profile",
    rolesMessage: "Roles",
    addRolesMessage: "Add Roles",
    roleCreationDateMsg: "Role Creation Date",
    roleCreatedMsg: "Role Created",
    roleEditedMsg: "Role Updated",
    viewRoleMsg: "View Role",
    deleteRoleMsg: "Archive Role",
    deleteRoleConfirmationMsg:
      "Are you sure you want to archive the role named {msg}",
    roleDeletedMsg: "Role Archived",
    availableRolesMsg: "Available Roles",
    assignedRolesMsg: "Assigned Roles",
    transferAllRolesMsg: "Transfer All Available Roles",
    transferAllRolesConfirmationMsg:
      "Are you sure you want to transfer all avaible roles?",
    removeAllRolesMsg: "Unassign all roles",
    removeAllRolesConfirmationMsg:
      "Are you sure you want to unassign all roles?",
    userRolesUpdatedMsg: "User Roles Updated",
    logsMessage: "Logs",
    usersMessage: "Users",
    editUserMessage: "Edit User",
    createUserMessage: "Create User",
    addUserMessage: "Add User",
    showUserMessage: "View User",
    deleteUserMessage: "Archive User",
    activateUserMsg: "Activate User",
    deactivateUserMsg: "Deactivate User",
    userDeletedMsg: "User Deleted",
    deleteUserConfirmationMsg:
      "Are you sure you want to delete the user named {msg}",
    activateUserConfirmationMsg:
      "Are you sure you want to activate the user named {msg}",
    deactivateUserConfirmationMsg:
      "Are you sure you want to deactivate the user named {msg}",
    userMessage: "User",
    userCreatedMsg: "User Created",
    userEditedMsg: "User Saved",
    userDeletedMsg: "User Deleted",
    userActivatedMsg: "User Activated",
    userDeactivatedMsg: "User Deactivated",
    userDetailsMsg: "User Details",
    userRolesMsg: "User Roles",
    updateUserRolesMsg: "Update Roles",
    permissionsMessage: "Permissions",
    addPermissionMessage: "Add Permission",
    permissionCreationDateMsg: "Permission Creation Date",
    permissionNameMsg: "Permission Name",
    permissionCreatedMsg: "Permission Created",
    permissionEditedMsg: "Permission Saved",
    permissionDeletedMsg: "Permission Deleted",
    deletePermissionConfirmationMsg:
      "Are you sure you want to delete the permission named {msg}",
    deletePermissionMessage: "Delete Permission",
    transferAllPermissionsMsg: "Transfer All Permissions",
    transferAllPermissionsConfirmationMsg:
      "Are you sure you want to transfer all available permissions?",
    availablePermissionsMsg: "Available Permissions",
    assignedPermissionsMsg: "Assigned Permissions",
    removeAllPermissionsMsg: "Unassign All Permissions",
    removeAllPermissionsConfirmationMsg:
      "Are you sure you want to unassign all permissions?",

    dashboardMessage: "Dashboard",
    roleMessage: "Role",
    createRoleMsg: "Create Role",
    editRoleMsg: "Edit Role",
    roleNameMsg: "Role Name",
    availableItemsMsg: "Available Items",
    assignedItemsMsg: "Assigned Items",
    transferAllItemsMsg: "Transfer All Items",
    transferAllItemsConfirmationMsg:
      "Are you sure you want to transfer all items?",
    removeAllItemsMsg: "Unassign All Items",
    removeAllItemsConfirmationMsg:
      "Are you sure you want to unassign all items?",

    invalidOTPMsg: "Invalid OTP. Please try again.",
    invalidCredentialsMsg: "Invalid email or password.",
    inputOTPMsg: "Enter the OTP sent to your email.",
    codeMessage: "Code is required",
    forgotPasswordMessage: "Forgot Password?",
    loginEmailMsg: "Wrong email or password/Account is not activated.",
    loginErrorMsg: "error",
    submitMessage: "Submit",
    uploadProfilePicMsg: "Upload Profile Picture",
    updateProfileMsg: "Update Profile",
    genderMsg: "Gender",
    dateOfBirthMsg: "Date of Birth",
    updateMsg: "Update",
    changePasswordMsg: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    rolesMsg: "Role(s)",
    activeMsg: "Active",
    inactiveMsg: "Inactive",
    createdOnMsg: "Created On",
    kindlySelectFileMsg: "Kindly select a file",
    passwordChangeConfirmMsg: "Are you sure you want to change your password?",
    passwordUpdateMsg:
      "Password Updated Successfully. Please login again to continue using the system.",
    passwordMatchFailMsg: "Current Password does not match with our records",
    profileUpdateConfirmMsg: "Are you sure you want to update your profile?",
    profileUpdateSuccessMsg: "Profile Updated Successfully",
    profilePicUploadSuccessMsg: "Profile Picture Uploaded Successfully",
    manageItemsMessage: "Manage Items",
    dashboardMsg: "Dashboard",
    filterMsg: "Filter",
    searchMsg: "Search",
    searchFilterMsg: "Search Filter",
    resetSearchMsg: "Reset Search",
    advancedSearchMsg: "Advanced Search",
    totalMsg: "Total:",
    numberOfSiteVisitsMsg: "Number of Site Visits",
    numberOfDocumentViewsMsg: "Number of Document Views",
    numberOfDocumentsMsg: "Number of Documents",
    documentyByCountryMsg: "Number of Documents by Country",
    numberOfFileTypesMsg: "File Types",
    registeredUsersMsg: "Registered Users",
    totalSiteVisitsMsg: "Total Site Visits",
    uploadedFilesMsg: "File Uploads",
    downloadedFilesMsg: "File Downloads",
    enterSearchTermMsg: "Enter search term",
    searchTermExampleMsg: "e.g Market Research",

    myWorkflowApprovalsMsg: "My Approvals",
    workflowManagementMsg: "Workflow Manager",
    workflowMappingMsg: "Workflow Mapping",
    workflowMsg: "Workflow",
    viewWorkflowMsg: "View Workflow",
    addWorkflowMsg: "Add Workflow",
    editWorkflowMsg: "Edit Workflow",
    noWorkflowFoundMsg: "No workflow found...",
    workflowNameMsg: "Workflow Name",
    applicationNameMsg: "Application Name",
    actionsMsg: "Actions",
    nodesMsg: "Nodes",
    addWorkflowNodeMsg: "Add Workflow Node",
    editWorkflowNodeMsg: "Edit Workflow Node",
    noWorkflowNodeFoundMsg: "No workflow node found...",
    nodeNameMsg: "Node Name",
    nodeTypeMsg: "Node Type",
    assigneeTypeMsg: "Assignee Type",
    assigneeMsg: "Assignee",
    assigneeIdMsg: "Assignee Id",
    isFirstApproverMsg: "Is First Approver?",
    workflowAddedSuccessfullyMsg: "Workflow added successfully.",
    workflowUpdatedSuccessfullyMsg: "Workflow updated successfully.",
    workflowDeletedSuccessfullyMsg: "Workflow deleted successfully.",
    workflowDeleteConfirmMsg: "Are you sure you want to delete workflow?",
    applicationMsg: "Application",
    workflowAttachmentsMsg: "Workflow Attachments",
    workflowActionsMsg: "Workflow Actions",
    workflowActionMsg: "Workflow Action",
    viewWorkflowActionLogsMsg: "View Workflow Action Logs",
    pendingApplicationsMsg: "Pending Applications",
    approvalHistoryMsg: "Approval History",
    noApprovalsFoundMsg: "No approvals found...",
    receivedMsg: "Received",
    applicationDetailsMsg: "Application Details",
    applicationFormMsg: "Application Form",
    commentsMsg: "Comments",
    selectActionMsg: "Select Action",
    approveMsg: "Approve",
    rejectMsg: "Reject",
    exportPdfMsg: "Export PDF",
    exportCsvMsg: "Export CSV",
    workflowActionLogupdatedsuccessMsg:
      "Workflow Action Log updated successfully.",
    workflowActionLogaddedsuccessMsg: "Workflow Action Log added successfully.",
    workflowActionLogdeletewarningMsg:
      "Are you sure you want to delete workflow action log?",
    workflowActionLogdeletesuccessMsg:
      "Workflow Action Log deleted successfully.",
    workflowActionLogSubmitConfirmationMsg:
      "Are you sure you want to submit workflow action?",
    workflowActionLogSubmitSuccessMsg:
      "Workflow Action has been submitted successfully",
    workflowActionBlankErrorMsg: "Error! Workflow Action cannot be blank",
    workflowNodesMsg: "Workflow Nodes",
    viewWorkflowNodesMsg: "View Workflow Nodes",
    stepsMsg: "Steps",
    workflowNodeUpdatedSuccessMsg: "Workflow Node Updated Successfully.",
    workflowNodeAddedSuccessMsg: "Workflow Node Added Successfully.",
    workflowNodeDeleteWarningMsg:
      "Are you sure you want to delete Workflow Node?",
    workflowNodeDeleteSuccessMsg: "Workflow Node Deleted Successfully.",
    workflowStepsMsg: "Workflow Steps",
    viewWorkflowStepsMsg: "View Workflow Steps",
    addWorkflowStepsMsg: "Add Workflow Steps",
    addWorkflowStepMsg: "Add Workflow Step",
    editWorkflowStepMsg: "Edit Workflow Step",
    noWorkflowStepsFoundMsg: "No workflow steps found...",
    currentNodeMsg: "Current Node",
    nextNodeMsg: "Next Node",
    conditionsMsg: "Conditions",
    workflowStepUpdateSuccessMsg: "Workflow Step Updated Successfully.",
    workflowStepAddedSuccessMsg: "Workflow Step Added Successfully.",
    workflowStepDeleteWarningMsg: "Are you sure you want to delete workflow workflownextstep?",
    workflowStepDeleteSuccessMsg: "Workflow Step Deleted Successfully.",

    showMsg: "Show",
    archiveMsg: "Archive",
    submitMsg: "Submit",
    notApplicableMsg: "N/A",

    manageItemsMsg: "Manage Items",
    addItemMsg: "Add Item",
    editItemMsg: "Edit Item",
    noItemFoundMsg: "No item found...",
    titleMsg: "Title",
    descriptionMsg: "Description",
    typeMsg: "Type",
    classificationMsg: "Classification",
    accessLevelMsg: "Access Level",
    tagsMsg: "Tags",
    tagsHintMsg: "Type in any relevant tags here",
    programmeMsg: "Programme",
    projectMsg: "Project",
    abstractMsg: "Abstract",
    eventOrPublishDateMsg: "Event/Publish Date",
    latitudeMsg: "Latitude",
    longitudeMsg: "Longitude",
    downloadMsg: "Download",
    coordinatesMsg: "Coordinates",
    itemIDMsg: "Item ID",
    uploadedByMsg: "Uploaded By",
    uploadedOnMsg: "Uploaded On",
    lastUpdateByMsg: "Last Update By",
    lastUpdateOnMsg: "Last Update On",
    itemUpdatedSuccesfullyMsg: "Item Updated Successfully",
    itemSubmittedSuccessfullyMsg: "Item Submitted Successfully",
    itemDeleteConfirmationMsg: "Are You Sure You Want to Archive Item",
    itemDeletedSuccessfullyMsg: "Item Submitted for Archiving Successfully",
    itemUploadedSuccessfullyMsg: "Item Uploaded Successfully",
    uploadItemMsg: "Upload Item",
    selectItemToUploadMsg: "Select Item to Upload",
    noItemsMsg: "No Items",
    noPermissionsMsg: "No permissions",

    genderMessage: "Gender",
    countryMessage: "Country",
    DateOfBirthMsg: "Date of Birth",
    itemDownloadedSuccessfullyMsg: "Download Successful",
    categoriesSectionTitle: "Categories",
    searchPageTitle: "Search",
    selectItemTypeMsg: "Please select an item type",
    itemsNotFoundMsg: "No items matched your search",
    publicationPageTitle: "Publications",
    ipBiosafetyLawsPageTitle: "IP & Biosafety Laws",

    messageSentMsg: "Message sent Successfully.",
    pleaseAddYourMessageMsg: "Please add your message",
    messageMsg: "Message",
    subjectMsg: "Subject",

    closeMessage: "close",
    quickLinksMessage: "Quick links",
    ProgrammeMsg: "Programme",
    ProjectMsg: "Project",
    CountryMsg: "Country",
    TagsMsg: "Tags",
    ReadMsg: "Read",
    SearchMsg: "Search",
    allMsg: "ALL",
    imagesMsg: "IMAGES",
    videosMsg: "VIDEOS",
    audiosMsg: "AUDIOS",
    AbstractMsg: "Abstract",
    NextMsg: "Next",
    PreviousMsg: "Previous",
    clickToViewMsg: "Click to view",
    faqMessage: "Frequently asked questions",
    opportunitiesMessage: "Opportunities",
    faqModulesMsg: "FAQ Modules",
    createFaqModuleMsg: "Create FAQ Module",
    faqModulesUpdatedMsg: "FAQ Modules Updated",
    faqChangeOrderHelpMsg: "Use the arrows or click and drag items to change their order",
    changeOrderMsg: "Change Order",
    orderMsg: "Order",
    moduleMsg: "Module",
    deleteFaqModuleMsg: "Delete FAQ Module",
    deleteFaqModuleConfirmationMsg: "Are you sure you want to delete the module named",
    cancelMsg: "Cancel",
    createFaqModuleMsg: "Create FAQ Module",
    editFaqModuleMsg: "Edit FAQ Module",
    moduleDetailsMsg: "Module Details",
    moduleNameMsg: "Module Name",
    typeModuleNameHere: "Type Module Name Here",
    typeQuestionHere: "Type Question Here",
    typeResponseHere: "Type Response Here",
    questionMsg: "Question | Questions",
    addQuestionMsg: "Add Question",
    faqQuestionHelpMsg: 'Select a question to edit it. Click and Drag a question to change its order in the list.',
    removeQuestionMsg: "Remove Question",
    responseMsg: "Response",
    pleaseRemoveDefaultTextMsg: "Please remove default text",
    blogsMessage: "Blogs",
    blogsPageTitle: "Blogs",
    manageFAQsMsg: "Manage FAQs",
  },

  //French
  fr: {
    anErrorOccurredMsg: "Une erreur s'est produite. Veuillez réessayer.",
    welcomeMessage:
      "Bienvenue sur le Hub de gestion des connaissances de l'AATF",
    slogan: "Hub de gestion des connaissances",
    discoverMessage: " Découvrez tout pour vous aider dans votre parcours",
    whatYouGetMessage: "Ce que vous obtenez",
    productDevelopment: "DÉVELOPPEMENT ET DÉPLOIEMENT DE PRODUITS",
    productDevelopmentMessage:
      "Ce programme englobe les fonctions amont du pipeline de développement technologique, allant de la prospection et de l'accès au développement (y compris le croisement de traits/agroécologique et l'adaptation). Il couvre la preuve de concept technologique, la détermination de la faisabilité par le biais d'une analyse coûts-avantages (ACA), les tests de produits/variétés, la mise en circulation et l'enregistrement, les démonstrations technologiques et les discussions techniques.",
    enablingEnvironment: "ENVIRONNEMENT FAVORABLE",
    enablingEnvironmentMessage:
      "Par le biais de ce programme, l'AATF cherche à favoriser la matérialisation du développement, de la mise en circulation et de la commercialisation des technologies tant au niveau national que régional. Cela est réalisé grâce à des efforts de collaboration avec les gouvernements et les organisations pertinentes pour l'élaboration et la mise en œuvre de politiques, lois, réglementations, directives, processus et institutions clairement articulées. Ces efforts sont soutenus par une volonté politique et les capacités et ressources requises.",
    investment: "ACCÈS À L'INVESTISSEMENT",
    investmentMessage:
      "Ce programme vise à faciliter la commercialisation et l'expansion des produits développés dans le cadre des projets de partenariat de l'AATF. Il comprend trois composantes cruciales : premièrement, la facilitation de systèmes de semences efficaces et rentables pour fournir directement des produits aux agriculteurs. Deuxièmement, un soutien à la gestion est fourni pour garantir l'utilisation responsable de ces produits. Et enfin, un développement de marché spécifique à la chaîne de valeur est entrepris pour renforcer l'accès et l'adoption.",
    searchButton: "Commencer la recherche",
    searchMessage: "Recherche",
    searchHereMessage: "Rechercher ici",
    viewMoreMessage: "Voir plus",
    readMessage: "Lire",
    recommendedResearch: "Recherche recommandée",
    recommendedResearchMessage:
      "Explorez notre sélection soigneusement élaborée de recherches recommandées, présentant les dernières études, innovations et idées façonnant l'avenir de l'agriculture en Afrique.",
    latestResearch: "Dernières recherches",
    latestResearchMessage:
      "Restez à jour avec les dernières recherches en matière d'innovation et de technologie agricole, abordant les défis et opportunités émergents à travers l'Afrique. Cette section met en lumière les études récemment publiées, les découvertes révolutionnaires et les développements de pointe qui façonnent l'avenir de l'agriculture.",
    whoWeWorkWith: "Avec qui nous travaillons",
    welcomeDetailsMsg:
      "Votre passerelle pour accéder, partager et gérer des connaissances vitales qui alimentent l'innovation et la croissance dans l'agriculture à travers l'Afrique. Cette plateforme est conçue pour renforcer la prise de décision avec des données, des rapports et des informations d'experts, favoriser la collaboration en connectant des équipes et des projets et stimuler l'innovation grâce à des technologies agricoles de pointe et des success stories. Explorez les ressources, partagez des idées et contribuez à construire un avenir de l'agriculture basé sur les connaissances pour l'Afrique.",
    loginMessage: "Connexion",
    homeMessage: "Accueil",
    publicationMessage: "Publications",
    IPBioSafetyLawsMessage: "Lois sur la PI et la biosécurité",
    mediaMessage: "Fichiers multimédias",
    projectsMessage: "Projets",
    opportunitiesMessage: "Opportunités",
    faqsMessage: "FAQ",
    faqsInFullMessage: "Foire aux questions",
    aboutMsg: "À propos",
    aboutUsMsg: "À propos de nous",
    contactUsMsg: "Contactez-nous",
    quickLinksMsg: "Liens rapides",
    termsAndConditionsMsg: "Termes et conditions",
    allRightsReservedMsg: "Tous droits réservés",
    signOutMessage: "Déconnexion",
    emailMessage: "E-Mail",
    createAccountMessage: "Créer un compte",
    firstNameMessage: "Prénom",
    middleNameMessage: "Deuxième prénom",
    lastNameMessage: "Nom de famille",
    nameMessage: "Nom",
    phoneNumberMessage: "Numéro de téléphone",
    passwordMessage: "Mot de passe",
    confirmPasswordMessage: "Confirmer le mot de passe",
    registerMessage: "S'inscrire",
    createMessage: "Créer",
    sendLinkMessage: "Envoyez-moi un lien..",
    sendMsg: "Envoyer",
    confirmOTPMessage: "Confirmer le code..",
    inputIsRequiredMessage: "L'entrée est requise",
    codeInputIsRequiredMessage: "Veuillez saisir votre code",
    minimum12CharactersMsg: "Minimum 12 caractères",
    mustHaveAtLeastOneUppercaseCharacterMsg:
      "Doit contenir au moins une lettre majuscule",
    mustHaveAtLeastOneNumberMsg: "Doit contenir au moins un chiffre",
    mustHaveAtLeastOneSpecialCharacterMsg:
      "Doit contenir au moins un caractère spécial [!@#$%.]",
    mustNotHaveASpecialCharacterMsg:
      "Ne doit pas contenir de caractère spécial",
    passwordIsRequiredMsg: "Mot de passe requis",
    backButton: "Retour",
    viewMoreLocation: "Emplacement",
    seeMedia: "Voir les médias",
    viewMorePeople: "Personnes",
    viewMoreStatus: "Statut",
    viewMoreCountry: "Pays",
    countryMsg: "Pays",
    phoneNumberIsRequiredMsg: "Le numéro de téléphone est requis",
    mustBeAnIntegerMsg:
      "Le numéro de téléphone ne doit contenir que des chiffres",
    minimum10DigitsMsg:
      "Le numéro de téléphone doit comporter un minimum de 10 chiffres",
    passwordConfirmIsRequiredMsg: "La confirmation du mot de passe est requise",
    passwordsDoNotMatchMsg: "Les mots de passe ne correspondent pas",
    accountActiveMsg: "Compte actif",
    accountCreationDateMsg: "Date de création du compte",
    actionMsg: "Action | Actions",
    yesMsg: "Oui",
    noMsg: "Non",
    viewMsg: "Voir",
    editMsg: "Modifier",
    deleteMsg: "Supprimer",
    loadingMsg: "Chargement",
    pleaseWaitMsg: "Veuillez patienter",
    saveMsg: "Enregistrer",
    maximumCharsMsg: "Maximum {count} caractères",
    minimumCharsMsg: "Minimum {count} caractères",
    noResultsMatchedSearchMsg: "Aucun résultat ne correspond à votre recherche",
    noResultsMsg: "Pas de résultats",
    closeMsg: "Fermer",
    workflowBillingNodeError:
      "Erreur! Impossible de soumettre sans articles facturables",

    emailIsRequiredMsg: "E-Mail est requis",
    emailMustBeValidMsg: "E-Mail doit être valide",
    profileMessage: "Profil",
    rolesMessage: "Rôles",
    addRolesMessage: "Ajouter des rôles",
    roleCreationDateMsg: "Date de création du rôle",
    roleCreatedMsg: "Rôle créé",
    roleEditedMsg: "Rôle mis à jour",
    viewRoleMsg: "Voir le rôle",
    deleteRoleMsg: "Supprimer le rôle",
    deleteRoleConfirmationMsg:
      "Êtes-vous sûr de vouloir supprimer le rôle nommé {msg}",
    roleDeletedMsg: "Rôle supprimé",
    availableRolesMsg: "Rôles disponibles",
    assignedRolesMsg: "Rôles attribués",
    transferAllRolesMsg: "Transférer tous les rôles disponibles",
    transferAllRolesConfirmationMsg:
      "Êtes-vous sûr de vouloir transférer tous les rôles disponibles?",
    removeAllRolesMsg: "Désattribuer tous les rôles",
    removeAllRolesConfirmationMsg:
      "Êtes-vous sûr de vouloir désattribuer tous les rôles?",
    userRolesUpdatedMsg: "Rôles utilisateur mis à jour",
    logsMessage: "Journaux",
    usersMessage: "Utilisateurs",
    editUserMessage: "Modifier l'utilisateur",
    createUserMessage: "Créer un utilisateur",
    addUserMessage: "Ajouter un utilisateur",
    showUserMessage: "Voir l'utilisateur",
    deleteUserMessage: "Supprimer l'utilisateur",
    userDeletedMsg: "Utilisateur supprimé",
    deleteUserConfirmationMsg:
      "Êtes-vous sûr de vouloir supprimer l'utilisateur nommé {msg}",
    userMessage: "Utilisateur",

    userCreatedMsg: "Utilisateur créé",
    userEditedMsg: "Utilisateur enregistré",
    userDeletedMsg: "Utilisateur supprimé",
    userDetailsMsg: "Détails de l'utilisateur",
    userRolesMsg: "Rôles de l'utilisateur",
    updateUserRolesMsg: "Mettre à jour les rôles",
    permissionsMessage: "Autorisations",
    addPermissionMessage: "Ajouter une autorisation",
    permissionCreationDateMsg: "Date de création de l'autorisation",
    permissionNameMsg: "Nom de l'autorisation",
    permissionCreatedMsg: "Autorisation créée",
    permissionEditedMsg: "Autorisation enregistrée",
    permissionDeletedMsg: "Autorisation supprimée",
    deletePermissionConfirmationMsg:
      "Êtes-vous sûr de vouloir supprimer l'autorisation nommée {msg}",
    deletePermissionMessage: "Supprimer l'autorisation",
    transferAllPermissionsMsg: "Transférer toutes les autorisations",
    transferAllPermissionsConfirmationMsg:
      "Êtes-vous sûr de vouloir transférer toutes les autorisations?",
    availablePermissionsMsg: "Autorisations disponibles",
    assignedPermissionsMsg: "Autorisations attribuées",
    removeAllPermissionsMsg: "Désattribuer toutes les autorisations",
    removeAllPermissionsConfirmationMsg:
      "Êtes-vous sûr de vouloir désattribuer toutes les autorisations?",

    dashboardMessage: "Tableau de bord",
    roleMessage: "Rôle",
    createRoleMsg: "Créer un rôle",
    editRoleMsg: "Modifier le rôle",
    roleNameMsg: "Nom du rôle",
    availableItemsMsg: "Articles disponibles",
    assignedItemsMsg: "Articles attribués",
    transferAllItemsMsg: "Transférer tous les articles",
    transferAllItemsConfirmationMsg:
      "Êtes-vous sûr de vouloir transférer tous les articles?",
    removeAllItemsMsg: "Désattribuer tous les articles",
    removeAllItemsConfirmationMsg:
      "Êtes-vous sûr de vouloir désattribuer tous les articles?",
    invalidOTPMsg: "OTP invalide. Veuillez réessayer.",
    invalidCredentialsMsg: "E-mail ou mot de passe invalide.",
    inputOTPMsg: "Entrez l'OTP envoyé à votre e-mail.",
    codeMessage: "Le code est requis",
    forgotPasswordMessage: "Mot de passe oublié?",
    loginEmailMsg: "Mauvais e-mail ou mot de passe/Compte non activé.",
    loginErrorMsg: "erreur",
    submitMessage: "Soumettre",
    uploadProfilePicMsg: "Télécharger une photo de profil",
    updateProfileMsg: "Mettre à jour le profil",
    genderMsg: "Sexe",
    dateOfBirthMsg: "Date de naissance",
    updateMsg: "Mettre à jour",
    changePasswordMsg: "Changer le mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    rolesMsg: "Rôle(s)",
    activeMsg: "Actif",
    inactiveMsg: "Inactif",
    createdOnMsg: "Créé le",
    kindlySelectFileMsg: "Veuillez sélectionner un fichier",
    passwordChangeConfirmMsg:
      "Êtes-vous sûr de vouloir changer votre mot de passe?",
    passwordUpdateMsg: "Mot de passe mis à jour avec succès",
    passwordMatchFailMsg:
      "Le mot de passe actuel ne correspond pas à nos enregistrements",
    profileUpdateConfirmMsg:
      "Êtes-vous sûr de vouloir mettre à jour votre profil?",
    profileUpdateSuccessMsg: "Profil mis à jour avec succès",
    profilePicUploadSuccessMsg: "Photo de profil téléchargée avec succès",
    manageItemsMessage: "Gérer les articles",
    dashboardMsg: "Tableau de bord",
    filterMsg: "Filtre",
    searchMsg: "Recherche",
    searchFilterMsg: "Filtre de recherche",
    resetSearchMsg: "Réinitialiser la recherche",
    advancedSearchMsg: "Recherche avancée",
    totalMsg: "Total:",
    numberOfSiteVisitsMsg: "Nombre de visites sur le site",
    numberOfDocumentViewsMsg: "Nombre de vues de documents",
    numberOfDocumentsMsg: "Nombre de documents",
    documentyByCountryMsg: "Nombre de documents par pays",
    numberOfFileTypesMsg: "Types de fichiers",
    registeredUsersMsg: "Utilisateurs enregistrés",
    totalSiteVisitsMsg: "Total des visites sur le site",
    uploadedFilesMsg: "Téléchargements de fichiers",
    downloadedFilesMsg: "Téléchargements de fichiers",
    enterSearchTermMsg: "Entrez le terme de recherche",
    searchTermExampleMsg: "par exemple recherche de marché",

    myWorkflowApprovalsMsg: "Mes approbations",
    workflowManagementMsg: "Gestion des workflows",
    workflowMappingMsg: "Mapping des workflows",
    workflowMsg: "Workflow",
    viewWorkflowMsg: "Voir le workflow",
    addWorkflowMsg: "Ajouter un workflow",
    editWorkflowMsg: "Modifier le workflow",
    noWorkflowFoundMsg: "Aucun workflow trouvé...",
    workflowNameMsg: "Nom du workflow",
    applicationNameMsg: "Nom de l'application",
    actionsMsg: "Actions",
    nodesMsg: "Nœuds",
    addWorkflowNodeMsg: "Ajouter un nœud de workflow",
    editWorkflowNodeMsg: "Modifier le nœud de workflow",
    noWorkflowNodeFoundMsg: "Aucun nœud de workflow trouvé...",
    nodeNameMsg: "Nom du nœud",
    nodeTypeMsg: "Type de nœud",
    assigneeTypeMsg: "Type de destinataire",
    assigneeMsg: "Destinataire",
    assigneeIdMsg: "ID du destinataire",
    isFirstApproverMsg: "Est le premier approbateur?",
    workflowAddedSuccessfullyMsg: "Workflow ajouté avec succès.",
    workflowUpdatedSuccessfullyMsg: "Workflow mis à jour avec succès.",
    workflowDeletedSuccessfullyMsg: "Workflow supprimé avec succès.",
    workflowDeleteConfirmMsg: "Êtes-vous sûr de vouloir supprimer le workflow?",
    applicationMsg: "Application",
    workflowAttachmentsMsg: "Pièces jointes du workflow",
    workflowActionsMsg: "Actions du workflow",
    workflowActionMsg: "Action du workflow",
    viewWorkflowActionLogsMsg: "Voir les journaux d'actions du workflow",
    pendingApplicationsMsg: "Applications en attente",
    approvalHistoryMsg: "Historique des approbations",

    noApprovalsFoundMsg: "Aucune approbation trouvée...",
    receivedMsg: "Reçu",
    applicationDetailsMsg: "Détails de l'application",
    applicationFormMsg: "Formulaire de demande",
    commentsMsg: "Commentaires",
    selectActionMsg: "Sélectionner une action",
    approveMsg: "Approuver",
    rejectMsg: "Rejeter",
    exportPdfMsg: "Exporter en PDF",
    exportCsvMsg: "Exporter en CSV",
    workflowActionLogupdatedsuccessMsg:
      "Journal d'actions du workflow mis à jour avec succès.",
    workflowActionLogaddedsuccessMsg:
      "Journal d'actions du workflow ajouté avec succès.",
    workflowActionLogdeletewarningMsg:
      "Êtes-vous sûr de vouloir supprimer le journal d'actions du workflow?",
    workflowActionLogdeletesuccessMsg:
      "Journal d'actions du workflow supprimé avec succès.",
    workflowActionLogSubmitConfirmationMsg:
      "Êtes-vous sûr de vouloir soumettre l'action du workflow?",
    workflowActionLogSubmitSuccessMsg:
      "L'action du workflow a été soumise avec succès",
    workflowActionBlankErrorMsg:
      "Erreur! L'action du workflow ne peut pas être vide",
    workflowNodesMsg: "Nœuds de workflow",
    viewWorkflowNodesMsg: "Voir les nœuds de workflow",
    stepsMsg: "Étapes",
    workflowNodeUpdatedSuccessMsg: "Nœud de workflow mis à jour avec succès.",
    workflowNodeAddedSuccessMsg: "Nœud de workflow ajouté avec succès.",
    workflowNodeDeleteWarningMsg:
      "Êtes-vous sûr de vouloir supprimer le nœud de workflow?",
    workflowNodeDeleteSuccessMsg: "Nœud de workflow supprimé avec succès.",
    workflowStepsMsg: "Étapes de workflow",
    viewWorkflowStepsMsg: "Voir les étapes de workflow",
    addWorkflowStepsMsg: "Ajouter des étapes de workflow",
    addWorkflowStepMsg: "Ajouter une étape de workflow",
    editWorkflowStepMsg: "Modifier l'étape de workflow",
    noWorkflowStepsFoundMsg: "Aucune étape de workflow trouvée...",
    currentNodeMsg: "Nœud actuel",
    nextNodeMsg: "Nœud suivant",
    conditionsMsg: "Conditions",
    workflowStepUpdateSuccessMsg: "Étape de workflow mise à jour avec succès.",
    workflowStepAddedSuccessMsg: "Étape de workflow ajoutée avec succès.",
    workflowStepDeleteWarningMsg: "Êtes-vous sûr de vouloir supprimer l'étape de workflow?",
    workflowStepDeleteSuccessMsg: "Étape de workflow supprimée avec succès.",

    showMsg: "Afficher",
    archiveMsg: "Archiver",

    submitMsg: "Soumettre",
    notApplicableMsg: "N/A",
    manageItemsMsg: "Gérer les articles",
    addItemMsg: "Ajouter un article",
    editItemMsg: "Modifier l'article",
    noItemFoundMsg: "Aucun article trouvé...",
    titleMsg: "Titre",
    descriptionMsg: "Description",
    typeMsg: "Type",
    classificationMsg: "Classification",
    accessLevelMsg: "Niveau d'accès",
    tagsMsg: "Mots-clés",
    tagsHintMsg: "Saisissez ici des mots-clés pertinents",
    programmeMsg: "Programme",
    projectMsg: "Projet",
    abstractMsg: "Résumé",
    eventOrPublishDateMsg: "Date de l'événement/de publication",
    latitudeMsg: "Latitude",
    longitudeMsg: "Longitude",
    downloadMsg: "Télécharger",
    coordinatesMsg: "Coordonnées",
    itemIDMsg: "ID de l'article",
    uploadedByMsg: "Téléchargé par",
    uploadedOnMsg: "Téléchargé le",
    lastUpdateByMsg: "Dernière mise à jour par",
    lastUpdateOnMsg: "Dernière mise à jour le",
    itemUpdatedSuccesfullyMsg: "Article mis à jour avec succès",
    itemSubmittedSuccessfullyMsg: "Article soumis avec succès",
    itemDeleteConfirmationMsg: "Êtes-vous sûr de vouloir archiver l'article",
    itemDeletedSuccessfullyMsg: "Article soumis pour archivage avec succès",
    itemUploadedSuccessfullyMsg: "Article téléchargé avec succès",
    uploadItemMsg: "Télécharger l'article",
    selectItemToUploadMsg: "Sélectionnez l'article à télécharger",
    noItemsMsg: "Aucun article",
    noPermissionsMsg: "Aucune autorisation",

    genderMessage: "Sexe",
    countryMessage: "Pays",
    DateOfBirthMsg: "Date de naissance",
    itemDownloadedSuccessfullyMsg: "Téléchargement réussi",
    categoriesSectionTitle: "Catégories",
    searchPageTitle: "Recherche",
    selectItemTypeMsg: "Veuillez sélectionner un type d'article",
    itemsNotFoundMsg: "Aucun article ne correspond à votre recherche",
    publicationPageTitle: "Publications",
    ipBiosafetyLawsPageTitle: "Lois sur la PI et la biosécurité",

    messageSentMsg: "Message envoyé avec succès.",
    pleaseAddYourMessageMsg: "Veuillez ajouter votre message",
    messageMsg: "Message",
    subjectMsg: "Sujet",

    closeMessage: "fermer",
    quickLinksMessage: "Liens rapides",
    ProgrammeMsg: "Programme",
    ProjectMsg: "Projet",
    CountryMsg: "Pays",
    TagsMsg: "Mots-clés",
    ReadMsg: "Lire",
    SearchMsg: "Recherche",
    allMsg: "TOUS",
    imagesMsg: "IMAGES",
    videosMsg: "VIDÉOS",
    audiosMsg: "AUDIOS",
    clickToViewMsg: "Cliquez pour voir",

    AbstractMsg: "résumé",
    NextMsg: "Suivante",
    PreviousMsg: "Précédente",
    faqMessage: "Questions fréquemment posées",
    opportunitiesMessage: "Opportunités",
  },

  //Swahili
  sw: {
    anErrorOccurredMsg: "Kumetokea hitilafu",
    welcomeMessage: "Karibu kwenye Kituo cha Maarifa cha AATF.",
    slogan: "Kituo cha Usimamizi wa Maarifa",
    whatYouGetMessage: "Unachopata",
    productDevelopment: "UTENGENEZAJI NA UPELEKAJI WA BIDHAA",
    productDevelopmentMessage:
      "Mpango huu unahusisha kazi za awali za mchakato wa maendeleo ya teknolojia, kuanzia utafutaji na upatikanaji wa maendeleo (ikiwa ni pamoja na upandaji/ufugaji wa sifa na marekebisho ya agroecological). Unajumuisha uthibitishaji wa teknolojia, uamuzi wa uwezekano kupitia uchambuzi wa gharama-manfaa (CBA), kupima bidhaa/aina, kuachilia na kusajili, maonyesho ya teknolojia, na mijadala ya kiufundi.",
    enablingEnvironment: "MAZINGIRA YANAYOWEZESHA",
    enablingEnvironmentMessage:
      "Kupitia mpango huu, AATF inatafuta kuhamasisha maendeleo ya teknolojia, kuachilia, na uuzaji katika ngazi za nchi na kikanda. Hii inafanikiwa kupitia ushirikiano na serikali na mashirika husika kwa ajili ya kutekeleza sera zilizo wazi, sheria, kanuni, miongozo, michakato, na taasisi. Juhudi hizi zinategemezwa na nia ya kisiasa na uwezo na rasilimali zinazohitajika.",
    investment: "UPATIKANAJI WA UWEKEZAJI",
    investmentMessage:
      "Mpango huu unalenga kuwezesha uuzaji na kupanua kwa bidhaa zinazotengenezwa kupitia miradi ya ushirikiano ya AATF. Unajumuisha vipengele vitatu muhimu: kwanza, kuwezesha mifumo ya mbegu yenye ufanisi na gharama nafuu ili kutoa bidhaa moja kwa moja kwa wakulima. Pili, msaada wa uangalizi hutolewa ili kuhakikisha matumizi sahihi ya bidhaa hizi. Mwisho, maendeleo ya soko maalum ya mnyororo wa thamani hufanyika ili kuimarisha upatikanaji na kupitishwa.",
    searchButton: "Anza Utafutaji",
    viewMoreMessage: "Tazama Zaidi",
    recommendedResearch: "Utafiti Unaopendekezwa",
    recommendedResearchMessage:
      "Suluhisho za teknolojia zinazotekelezeka ili kushinda vikwazo vya tija shambani.",
    latestResearch: "Utafiti wa Hivi Karibuni",
    latestResearchMessage:
      "Suluhisho za teknolojia zinazotekelezeka ili kushinda vikwazo vya tija shambani.",
    whoWeWorkWith: "Tunaofanya Nao Kazi",
    discoverMessage: "Gundua kila kitu kukusaidia kwenye safari yako",
    welcomeDetailsMsg:
      "Kituo cha Maarifa cha AATF ni jukwaa linalotoa habari kuhusu sheria za Mali ya Akili (IP) na Usalama wa Maisha ya Afrika. Jukwaa hilo pia hutoa habari kuhusu miradi ya AATF na fursa za ushirikiano.",
    loginMessage: "Ingia",
    homeMessage: "Nyumbani",
    publicationMessage: "Machapisho",
    IPBioSafetyLawsMessage: "Sheria za IP na Usalama wa Maisha",
    mediaMessage: "Vyombo vya Habari",
    projectsMessage: "Miradi",
    opportunitiesMessage: "Fursa",
    faqsMessage: "Maswali",
    signOutMessage: "Toka",
    emailMessage: "Barua pepe",
    createAccountMessage: "Unda Akaunti",
    firstNameMessage: "Jina la Kwanza",
    middleNameMessage: "Majina Mengine",
    lastNameMessage: "Jina la Mwisho",
    phoneNumberMessage: "Namba ya Simu",
    passwordMessage: "Nenosiri",
    confirmPasswordMessage: "Thibitisha Nenosiri",
    registerMessage: "Jiandikishe",
    createMessage: "Unda",
    sendLinkMessage: "Nipe kiungo..",
    confirmOTPMessage: "Thibitisha msimbo..",
    inputIsRequiredMessage: "Ingizo ni lazima",
    codeInputIsRequiredMessage: "Tafadhali ingiza msimbo wako",
    minimum12CharactersMsg: "Angalau herufi 12",
    mustHaveAtLeastOneUppercaseCharacterMsg: "Lazima iwe na herufi kubwa moja",
    mustHaveAtLeastOneNumberMsg: "Lazima iwe na nambari moja",
    mustHaveAtLeastOneSpecialCharacterMsg:
      "Lazima iwe na herufi maalum moja [!@#$%.]",
    passwordIsRequiredMsg: "Nenosiri ni lazima",
    emailIsRequiredMsg: "Barua pepe ni lazima",
    emailMustBeValidMsg: "Barua pepe lazima iwe halali",
    profileMessage: "Profaili",
    dashboardMessage: "Dashibodi",
    rolesMessage: "Vyeo",
    logsMessage: "Vichwa",
    usersMessage: "Watumiaji",
    backButton: "Rudi",
    seeMedia: "Tazama Vyombo vya Habari",
    viewMorePeople: "Watu",
    viewMoreStatus: "Hali",
    viewMoreCountry: "Nchi",
    viewMoreLocation: "Eneo",
    codeMessage: "Msimbo unahitajika",
    forgotPasswordMessage: "Umesahau Nenosiri?",
    loginEmailMsg: "Barua pepe au nenosiri si sahihi/Akaunti haijawashwa.",
    loginErrorMsg: "hitilafu",
    viewMoreMessage: "Tazama",
    categoriesSectionTitle: "Kategoria",
    searchPageTitle: "Tafuta",
    AbstractMsg: "Muhtasari",
    NextMsg: "Inayofuata",
    PreviousMsg: "Iliyotangulia",

    clickToViewMsg: "Bonyeza kuona",
    faqMessage: "Maswali yanayoulizwa mara kwa mara",
    opportunitiesMessage: "Fursa",
    blogsMessage: "Blogi",
    blogsPageTitle: "Blogi"

  },

  //Spanish
  es: {
    anErrorOccurredMsg: "Se produjo un error",
    welcomeMessage: "Bienvenido al Hub de Conocimiento de AATF.",
    slogan: "Centro de Gestión del Conocimiento",
    whatYouGetMessage: "Lo que Obtienes",
    productDevelopment: "DESARROLLO Y DESPLIEGUE DE PRODUCTOS",
    productDevelopmentMessage:
      "Este programa abarca las funciones iniciales de la cadena de desarrollo tecnológico, que van desde la exploración y el acceso al desarrollo (incluyendo la cría y adaptación de características/agroecológicas). Cubre la prueba de concepto de tecnología, la determinación de viabilidad a través de un análisis de costo-beneficio (CBA), pruebas de productos/variedades, liberación y registro, demostraciones tecnológicas y discusiones técnicas.",
    enablingEnvironment: "ENTORNO FACILITADOR",
    enablingEnvironmentMessage:
      "A través de este programa, AATF busca promover la materialización del desarrollo, liberación y comercialización de tecnologías a nivel nacional y regional. Esto se logra mediante esfuerzos de colaboración con gobiernos y organizaciones pertinentes para la implementación de políticas, leyes, regulaciones, directrices, procesos e instituciones claramente articuladas. Estos esfuerzos se apoyan en la buena voluntad política y las capacidades y recursos necesarios.",
    investment: "ACCESO A LA INVERSIÓN",
    investmentMessage:
      "Este programa se centra en facilitar la comercialización y escalado de productos desarrollados a través de proyectos de colaboración con AATF. Comprende tres componentes cruciales: primero, la facilitación de sistemas de semillas eficientes y rentables para entregar productos directamente a los agricultores. En segundo lugar, se proporciona apoyo de supervisión para asegurar el uso responsable de estos productos. Finalmente, se realiza el desarrollo de mercado específico para la cadena de valor, para fortalecer el acceso y la adopción.",
    searchButton: "Iniciar Búsqueda",
    viewMoreMessage: "Ver Más",
    recommendedResearch: "Investigación Recomendada",
    recommendedResearchMessage:
      "Soluciones tecnológicas prácticas para superar las limitaciones de productividad agrícola.",
    latestResearch: "Última Investigación",
    latestResearchMessage:
      "`Soluciones tecnológicas prácticas para superar las limitaciones de productividad",
    discoverMessage: "Descubre todo para ayudarte en tu camino",
    welcomeDetailsMsg:
      "El Hub de Conocimiento de AATF es una plataforma que proporciona información sobre las leyes de propiedad intelectual (PI) y bioseguridad en África. La plataforma también proporciona información sobre los proyectos de AATF y oportunidades de colaboración.",
    loginMessage: "Iniciar sesión",
    homeMessage: "Casa",
    publicationMessage: "Publicaciones",
    IPBioSafetyLawsMessage: "Leyes de PI y Bioseguridad",
    mediaMessage: "Medios de comunicación",
    projectsMessage: "Proyectos",
    opportunitiesMessage: "Oportunidades",
    faqsMessage: "Preguntas frecuentes",
    signOutMessage: "Desconectar",
    emailMessage: "Correo electrónico",
    createAccountMessage: "Crear cuenta",
    firstNameMessage: "Nombre de pila",
    middleNameMessage: "Otros nombres",
    lastNameMessage: "Apellido",
    phoneNumberMessage: "Número de teléfono",
    passwordMessage: "Contraseña",
    confirmPasswordMessage: "Confirmar contraseña",
    registerMessage: "Registrarse",
    createMessage: "Crear",
    sendLinkMessage: "Envíame un enlace..",
    confirmOTPMessage: "Confirmar código..",
    inputIsRequiredMessage: "La entrada es obligatoria",
    codeInputIsRequiredMessage: "Por favor, introduzca su código",
    minimum12CharactersMsg: "Mínimo 12 caracteres",
    mustHaveAtLeastOneUppercaseCharacterMsg:
      "Debe tener al menos un carácter en mayúscula",
    mustHaveAtLeastOneNumberMsg: "Debe tener al menos un número",
    mustHaveAtLeastOneSpecialCharacterMsg:
      "Debe tener al menos un carácter especial [!@#$%.]",
    passwordIsRequiredMsg: "Contraseña es obligatoria",
    emailIsRequiredMsg: "Correo electrónico es obligatorio",
    emailMustBeValidMsg: "El correo electrónico debe ser válido",
    profileMessage: "Perfil",
    dashboardMessage: "Tablero",
    rolesMessage: "Roles",
    logsMessage: "Registros",
    usersMessage: "Usuarios",
    backButton: "Volver",
    seeMedia: "Ver Medios",
    viewMorePeople: "Personas",
    viewMoreStatus: "Estado",
    viewMoreCountry: "País",
    viewMoreLocation: "Ubicación",
    codeMessage: "Se requiere código",
    forgotPasswordMessage: "¿Olvidaste tu contraseña?",
    loginEmailMsg:
      "Correo electrónico o contraseña incorrectos/La cuenta no está activada.",
    loginErrorMsg: "error",
    viewMoreMessage: "Ver",
    categoriesSectionTitle: "Categorias",
    searchPageTitle: "Buscar",
    NextMsg: "Próxima",
    PreviousMsg: "Previa",

    clickToViewMsg: "Haga clic para ver",
    faqMessage: "Preguntas frecuentes",
    opportunitiesMessage: "Oportunidades",
  },

  //German
  de: {
    anErrorOccurredMsg: "Ein Fehler ist aufgetreten",
    welcomeMessage: "Willkommen im AATF Knowledge Hub.",
    slogan: "Wissensmanagement-Zentrum",
    whatYouGetMessage: "Was Sie Bekommen",
    productDevelopment: "PRODUKTENTWICKLUNG & EINFÜHRUNG",
    productDevelopmentMessage:
      "Dieses Programm umfasst die vorgelagerten Funktionen der Technologieentwicklungs-Pipeline, von der Erkundung und dem Zugang zur Entwicklung (einschließlich Merkmal-/agroökologischer Züchtung und Anpassung). Es deckt den Nachweis des Konzepts der Technologie, die Machbarkeitsbestimmung durch Kosten-Nutzen-Analyse (CBA), Produkt-/Sortentests, Freigabe und Registrierung, Technologiedemonstrationen und technische Diskussionen ab.",
    enablingEnvironment: "FÖRDERLICHE UMGEBUNG",
    enablingEnvironmentMessage:
      "Durch dieses Programm strebt die AATF an, die Entwicklung, Freigabe und Kommerzialisierung von Technologien auf nationaler und regionaler Ebene zu fördern. Dies wird durch eine Zusammenarbeit mit Regierungen und relevanten Organisationen erreicht, um klar formulierte Richtlinien, Gesetze, Vorschriften, Leitlinien, Prozesse und Institutionen zu entwickeln und umzusetzen. Diese Bemühungen werden durch politischen Willen und die erforderlichen Fähigkeiten und Ressourcen unterstützt.",
    investment: "ZUGANG ZU INVESTITIONEN",
    investmentMessage:
      "Dieses Programm konzentriert sich auf die Förderung der Kommerzialisierung und des Skalierens von Produkten, die durch AATF-Partnerschaftsprojekte entwickelt wurden. Es umfasst drei wesentliche Komponenten: Erstens die Förderung effizienter und kostengünstiger Saatgutsysteme, um Produkte direkt an Landwirte zu liefern. Zweitens wird Unterstützung für eine verantwortungsvolle Nutzung dieser Produkte bereitgestellt. Schließlich wird eine wertschöpfungskettenspezifische Marktentwicklung betrieben, um den Zugang und die Akzeptanz zu stärken.",
    searchButton: "Suche Starten",
    viewMoreMessage: "Mehr Anzeigen",
    recommendedResearch: "Empfohlene Forschung",
    recommendedResearchMessage:
      "Praktische technologische Lösungen zur Überwindung von Produktivitätsbeschränkungen in der Landwirtschaft.",
    latestResearch: "Neueste Forschung",
    latestResearchMessage:
      "Praktische technologische Lösungen zur Überwindung von Produktivitätsbeschränkungen in der Landwirtschaft.",
    whoWeWorkWith: "Mit Wem Wir Zusammenarbeiten",
    discoverMessage: "Entdecken Sie alles, was Ihnen auf Ihrer Reise hilft",
    welcomeDetailsMsg:
      "Der AATF Knowledge Hub ist eine Plattform, die Informationen zu geistigem Eigentum (IP) und Biosicherheitsgesetzen in Afrika bereitstellt. Die Plattform bietet auch Informationen zu den AATF-Projekten und Möglichkeiten zur Zusammenarbeit.",
    loginMessage: "Anmeldung",
    homeMessage: "Zuhause",
    publicationMessage: "Veröffentlichungen",
    IPBioSafetyLawsMessage: "IP & Biosicherheitsgesetze",
    mediaMessage: "Medien",
    projectsMessage: "Projekte",
    opportunitiesMessage: "Möglichkeiten",
    faqsMessage: "FAQs",
    signOutMessage: "Ausloggen",
    emailMessage: "E-Mail",
    createAccountMessage: "Konto erstellen",
    firstNameMessage: "Vorname",
    middleNameMessage: "Andere Namen",
    lastNameMessage: "Nachname",
    phoneNumberMessage: "Telefonnummer",
    passwordMessage: "Passwort",
    confirmPasswordMessage: "Passwort bestätigen",
    registerMessage: "Registrieren",
    createMessage: "Erstellen",
    sendLinkMessage: "Schicken Sie mir einen Link..",
    confirmOTPMessage: "Code bestätigen..",
    inputIsRequiredMessage: "Eingabe ist erforderlich",
    codeInputIsRequiredMessage: "Bitte geben Sie Ihren Code ein",
    minimum12CharactersMsg: "Mindestens 12 Zeichen",
    mustHaveAtLeastOneUppercaseCharacterMsg:
      "Muss mindestens ein Großbuchstabe sein",
    mustHaveAtLeastOneNumberMsg: "Muss mindestens eine Nummer haben",
    mustHaveAtLeastOneSpecialCharacterMsg:
      "Muss mindestens ein Sonderzeichen haben [!@#$%.]",
    passwordIsRequiredMsg: "Passwort ist erforderlich",
    emailIsRequiredMsg: "E-Mail ist erforderlich",
    emailMustBeValidMsg: "E-Mail muss gültig sein",
    profileMessage: "Profil",
    dashboardMessage: "Armaturenbrett",
    rolesMessage: "Rollen",
    logsMessage: "Protokolle",
    usersMessage: "Benutzer",
    backButton: "Zurück",
    seeMedia: "Medien ansehen",
    viewMorePeople: "Personen",
    viewMoreStatus: "Status",
    viewMoreCountry: "Land",
    viewMoreLocation: "Standort",
    codeMessage: "Code ist erforderlich",
    forgotPasswordMessage: "Passwort vergessen?",
    loginEmailMsg: "Falsche E-Mail oder Passwort/Konto ist nicht aktiviert.",
    loginErrorMsg: "Fehler",
    viewMoreMessage: "Ansehen",
    categoriesSectionTitle: "Kategorien",
    searchPageTitle: "Suchen",
    NextMsg: "Nächste",
    PreviousMsg: "Vorherige",

    clickToViewMsg: "Klicken Sie, um anzuzeigen",
    faqMessage: "Häufig gestellte Fragen",
    opportunitiesMessage: "Gelegenheiten",
  },
};

const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
